export const TRACK_ADVANCED_LABELS = {
    details: 'Детальна інформація',
    detailsTrack: 'Детальна інформація по треку',
    fullDataTrack: 'Трек',
    detailsToggleButton: 'Показати/Приховати додаткову інформацію',
    totalTrackDistanceInKilometres: 'Загальна дистанція',
    motionStatusCodeDescription: 'Стан',
    satelliteCount: 'Супутників',
    satelliteCountShort: 'Супутн.',
    advancedTimeIndex: '#',
    deviceLastInfo: 'Останні дані',
    deviceCurrentInfo: 'Поточні дані',
    changeMapViewOnAdvancedIndex: 'Переміщати карту до ТЗ',
    changeMapViewOnAdvancedIndexHelper: 'Переміщати карту до ТЗ при зміні позиції(при умові закритого вікна інформації про стан транспорту)',
    showLastInfoDuringTrack: 'Детальна інформація при треку',
    skipFilters: 'Точки з помилками GPS',
    skipFiltersHelper: 'Технічний режим: показує всі точки з трекера, зокрема ті, де немає координат (0,0). Трек на карті стрибатиме — використовуйте для перевірки звʼязку та даних сенсорів.',
    stops: 'Зупинки',
    stopsVisited: 'Відвідані Зупинки',
    showPointVisited: 'Відвідані маршрутні точки',
    showGeoZoneVisited: 'Відвідані гео-зони',
    geoZoneVisited: 'Відвідані гео-зони',
    geoZonesVisited: 'Відвідання геозони',
    trackFirstFuelLevel: 'Початковий рівень палива',
    trackMinFuelLevel: 'Мінімальний рівень палива',
    trackMaxFuelLevel: 'Максимальний рівень палива',
    firstMotionTime: 'Початкова дата треку',
    lastMotionTime: 'Кінцева дата треку',
    baseInfoTrack: 'Загальна інформація',
    totalMovingDurationInMinutes: 'Загальна тривалість руху в хвилинах',
    totalStoppedDurationInMinutes: 'Загальна тривалість стоянки в хвилинах',
    totalMovingDuration: 'Загальна тривалість руху',
    totalStoppedDuration: 'Загальна тривалість стоянки',
    selectField:'Оберіть поля для відображення',
    chartTrack:'Графіки',
    showFieldsRowData:'Відображати поля по сирим даним',
}